import { Button, Card, Checkbox, Input, Table } from "antd";
import type { ColumnsType } from "antd/es/table";
import { renderDateFormated } from "../../../utils";
import { TicketContext } from "../../Shared/contexts/TicketContext";
import { useContext, useState } from "react";
import { useSelector } from "react-redux";
import { AuthenticationState } from "../../../interfaces/users";
import { useQuery } from "react-query";
import { api } from "../../../config";
import { toast } from "react-toastify";

interface HistoryInterfaceProps {
  ticketInfo?: any;
  schedule?: boolean;
  type?: 'assemble' | 'checklist' | 'measuring'
}

interface DataType {
  key: string;
  user: string;
  description: string;
  type: string;
  date: string;
}

export const Comment = ({
  ticketInfo,
  schedule = false,
  type = 'assemble'
}: HistoryInterfaceProps) => {
  const ticketContext = useContext(TicketContext) as any;
  const ticket = ticketInfo ? ticketInfo : ticketContext.ticket;
  const [content, setContent] = useState("");
  const [isContactMessage, setIsContactMessage] = useState(false);
  const { token, user } = useSelector((state: AuthenticationState) => state);
  const showContactCheckbox = type === "checklist" || type === "assemble";
  const { refetch } = useQuery(
    `tickets${type === 'assemble' ? `/${type}` : ''}`,
    () => api(token).get(`ticket/${type}/${ticketInfo.id}`),
    { refetchOnMount: false }
  );
  const { refetch: boardRefetch } = useQuery(
    "tickets/assemble/board",
    () => api(token).get(`tickets/assemble/board`),
    { enabled: false, refetchOnMount: false }
  );

  const handleSubmitMessage = async () => {
    try {
      if (!content) return toast.error("Digite uma mensagem");
      await api(token).post(`comments`, {
        content,
        userId: user?.id,
        [type === 'checklist' ? 'ticketId' : 'fieldReportId']: ticketInfo.id,
        ...(showContactCheckbox ? { isContact: isContactMessage } : {}),
      });
      setContent("");
      setIsContactMessage(false);
      await refetch();
      if (type === "assemble") {
        await boardRefetch();
      }
    } catch (error) {
      toast.error("Ocorreu um erro ao enviar a mensagem");
    }
  };

  const columns: ColumnsType<DataType> = [
    {
      title: "Data",
      dataIndex: "date",
      key: "date",
      width: 150,
      render: (date) => renderDateFormated(date),
      sorter: (a, b) => {
        const c: any = new Date(a.date);
        const d: any = new Date(b.date);
        return c - d;
      },
    },
    {
      title: "Usuário",
      dataIndex: "user",
      key: "user",
      width: 150,
    },
    {
      title: "Mensagem",
      dataIndex: "content",
      key: "content",
      render: (content) => (
        <span style={{ whiteSpace: "pre-wrap", wordBreak: "break-word" }}>
          {content}
        </span>
      ),
    },
  ];

  const history: DataType[] = ticket[type === 'checklist' ? 'comments' : 'Comment']?.map?.((log: any) => ({
    key: log.id,
    user: log.user?.fullName ?? "Sistema",
    content: log.content,
    date: log.createdAt,
  }));

  return (
    <div className="pt-1">
      <Card
        title="Mensagens"
        size="small"
        headStyle={{ color: " rgb(59 130 246)" }}
      >
        {!schedule && (
          <div className="flex flex-col gap-5 mb-5">
            <Input.TextArea
              onChange={(e) => setContent(e.target.value)}
              value={content}
            />
            {showContactCheckbox && (
              <Checkbox
                checked={isContactMessage}
                onChange={(e) => setIsContactMessage(e.target.checked)}
              >
                Contato com cliente
              </Checkbox>
            )}
            <Button
              onClick={handleSubmitMessage}
              color="primary"
              className="w-fit"
            >
              Enviar
            </Button>
          </div>
        )}

        <Table
          className=" overflow-auto"
          size="small"
          columns={columns}
          dataSource={history}
          pagination={false}
          style={{ maxHeight: "25vh" }}
        />
      </Card>
    </div>
  );
};
